<template>
  <div class="teacher">
    <div class="teacher-title">
      <h4>优秀讲师</h4>
    </div>
    <div class="teacher-body">
      <div class="teacher-item" v-for="item in teacherData" :key="item.id">
        <img :src="item.poster" alt="">
        <div class="teacher-info">
          <h5 class="teacher-name">{{ item.title }}<span class="teacher-tag">{{ item.summary }}</span></h5>
          <div class="summary">{{ item.content }}</div>
        </div>
      </div>
    </div>
    <!-- <div class="arrow">
      <i class="left-arrow iconfont icon-fangxiang-zuo"></i>
      <i class="right-arrow iconfont icon-fangxiang-you"></i>
    </div> -->
  </div>
</template>

<script>
export default {
  props: {
    data: Array
  },
  watch: {
    'data': function (val) {
      this.teacherData = val
    }
  },
  data () {
    return {
      teacherData: []
    }
  }
}
</script>

<style lang="less" scoped>
.teacher {
  position: relative;
  margin-top: 60px;
  &:hover {
    .arrow {
      display: block;
    }
  }
  .teacher-title {
    display: flex;
    margin-bottom: 30px;
    h4 {
      margin-right: 20px;
      font-family: "微软雅黑 Bold", "微软雅黑";
      font-weight: 700;
      font-style: normal;
      font-size: 24px;
      color: #303133;
      line-height: 24px;
    }
  }
  .teacher-body {
    display: flex;
    justify-content: space-between;

    .teacher-item {
      border-bottom-left-radius: 8px;
      border-bottom-right-radius: 8px;
      background-color: #fff;
      &:hover {
        box-shadow: 1px 1px 2px rgba(0, 0, 0, 0.1);
      }
      img {
        width: 220px;
        height: 260px;
        border-top-left-radius: 8px;
        border-top-right-radius: 8px;
      }
      .teacher-info {
        padding: 10px 10px 14px;
        .teacher-name {
          font-family: "微软雅黑";
          font-weight: 400;
          font-style: normal;
          font-size: 18px;
          color: #303133;
          line-height: 18px;
          .teacher-tag {
            margin-left: 10px;
            padding: 1px 5px;
            font-family: "微软雅黑";
            font-weight: 400;
            font-style: normal;
            font-size: 14px;
            color: #fc5e5e;
            line-height: 14px;
            background-color: #fff5f5;
            border-radius: 25px;
          }
        }
        .summary {
          margin: 10px 0;
          font-family: "微软雅黑";
          font-weight: 400;
          font-style: normal;
          font-size: 14px;
          color: #909399;
          line-height: 14px;

          width: 200px;
          /*⽂本溢出显⽰省略号*/
          white-space: nowrap;
          text-overflow: ellipsis;
          overflow: hidden;
        }
      }
    }
  }
  .arrow {
    display: none;
  }
}
.left-arrow,
.right-arrow {
  position: absolute;
  top: 50%;
  transform: translate(0, -50%);
}
.left-arrow {
  left: -5%;
}
.right-arrow {
  right: -5%;
}
</style>


// WEBPACK FOOTER //
// src/components/onlineSchool/diyTemplate/teacher.vue